export default "__VITE_ASSET__DeIwr4tp__"